export default __webpack_public_path__ + "static/media/accidente.5677505c.png";